<h1>Equipment Counting</h1>
<nb-tabset (changeTab)="onTabChange($event)">
  <nb-tab tabTitle="Counting Journals" active>
    <div class="d-flex">
      <grid-menu-button
        (click)="batchCreateJournal()"
        (keydown.enter)="batchCreateJournal()"
        [button]="buttons[0]"
      ></grid-menu-button>
      <grid-menu-button
        [button]="buttons[3]"
        [disabled]="!canRunVarianceSelected()"
        (click)="runVarianceSelectedJournalsConfirm(varianceDialog)"
        (keydown.enter)="runVarianceSelectedJournalsConfirm(varianceDialog)"
        >
      </grid-menu-button>
      <grid-menu-button
        [button]="buttons[4]"
        [disabled]="!canCompleteSelected()"
        (click)="completeSelectedJournalsConfirm(completeDialog)"
        (keydown.enter)="completeSelectedJournalsConfirm(completeDialog)"
        >
      </grid-menu-button>
      <grid-menu-button
        [button]="buttons[2]"
        [disabled]="!canCancelSelected()"
        (click)="cancelSelectedJournalsConfirm(cancelDialog)"
        (keydown.enter)="cancelSelectedJournalsConfirm(cancelDialog)"
        >
      </grid-menu-button>
      <grid-menu-button
        [button]="buttons[1]"
        [disabled]="!canDeleteSelected()"
        (click)="deleteSelectedJournalsConfirm(deleteDialog)"
        (keydown.enter)="deleteSelectedJournalsConfirm(deleteDialog)"
        >
      </grid-menu-button>
      <grid-menu-button
        [button]="buttons[5]"
        [disabled]="!canShareSelected()"
        (click)="shareSelectedJournal(shareDialog)"
        (keydown.enter)="shareSelectedJournal(shareDialog)"
        >
      </grid-menu-button>
    </div>

    <div class="equipment-counting-journal-content-container">
      <div class="list-section">
        <next-object-list
          #journalList
          object="EquipmentCountingJournal"
          [height]="600"
          [autoHeight]="true"
          [pagination_count]="100"
          [hideToolBar]="false"
          [hideQueues]="false"
          [hideControlBar]="false"
          [filters]="filters"
          [showCheckbox]="true"
          rowSelection="multiple"
          (onDoubleClick)="viewJournalDetail($event)"
          (onSelect)="onJournalSelect($event)"
        ></next-object-list>
      </div>
    </div>

    <!-- Delete Journal Confirmation Dialog -->
    <ng-template #deleteDialog let-data let-ref="dialogRef">
      <nb-card accent="danger">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Delete Journal(s)?
        </nb-card-header>
        <nb-card-body>
          <div style="display: flex; justify-content: center">
            <nb-icon
              style="font-size: 4rem; color: #ff3d71"
              icon="trash-2-outline"
            ></nb-icon>
          </div>
          <p>
            This will permanently <b>delete</b>
            <b>{{ getDeletableJournalsCount() }}</b> journal(s).
          </p>
          <p>This action cannot be undone.</p>
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: space-between; gap: 8px"
          >
          <button
            nbButton
            (click)="ref.close()"
            [disabled]="isDeletingJournals"
            >
            Cancel
          </button>
          <button
            nbButton
            status="danger"
            (click)="deleteSelectedJournals(ref)"
            [disabled]="isDeletingJournals"
            >
            @if (!isDeletingJournals) {
              <span>Delete Journal(s)</span>
            }
            @if (isDeletingJournals) {
              <i
                class="fa-solid fa-spinner fa-spin"
              ></i>
            }
            @if (isDeletingJournals) {
              <span> Processing...</span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Share Journal Link Dialog -->
    <ng-template #shareDialog let-data let-ref="dialogRef">
      <nb-card style="width: 420px; max-width: 90vw">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Share Journal
        </nb-card-header>
        <nb-card-body>
          <p style="margin-bottom: 8px">
            Anyone with this link can view this journal for 14 days.
          </p>
          @if (isLoadingShareLink) {
            <div style="display: flex; justify-content: center; padding: 8px">
              <i class="fa-solid fa-spinner fa-spin"></i>
            </div>
          }
          @if (!isLoadingShareLink && shareLinkURL) {
            <nb-form-field>
              <input
                id="ecj-list-share-link-input"
                aria-label="Share link URL"
                nbInput
                fullWidth
                readonly
                [value]="shareLinkURL"
                />
              <button
                nbSuffix
                nbButton
                ghost
                type="button"
                (click)="copyShareLink()"
                >
                <nb-icon
                  [icon]="shareLinkCopied ? 'checkmark-outline' : 'copy-outline'"
                  pack="eva"
                ></nb-icon>
              </button>
            </nb-form-field>
          }
          @if (!isLoadingShareLink && batchShareLinkURL) {
            <p style="margin: 16px 0 8px">
              This journal was created in a batch. The batch link combines
              all journals from the batch into one searchable page.
            </p>
            <nb-form-field>
              <input
                id="ecj-list-batch-share-link-input"
                aria-label="Batch share link URL"
                nbInput
                fullWidth
                readonly
                [value]="batchShareLinkURL"
                />
              <button
                nbSuffix
                nbButton
                ghost
                type="button"
                (click)="copyBatchShareLink()"
                >
                <nb-icon
                  [icon]="batchShareLinkCopied ? 'checkmark-outline' : 'copy-outline'"
                  pack="eva"
                ></nb-icon>
              </button>
            </nb-form-field>
          }
          @if (!isLoadingShareLink && !shareLinkURL) {
            <p style="color: #ff3d71">
              Unable to generate a share link. Please try again.
            </p>
          }
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: flex-end"
          >
          <button nbButton (click)="ref.close()">Close</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Cancel Journal Confirmation Dialog -->
    <ng-template #cancelDialog let-data let-ref="dialogRef">
      <nb-card accent="danger">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Cancel Journal(s)?
        </nb-card-header>
        <nb-card-body>
          <div style="display: flex; justify-content: center">
            <nb-icon
              style="font-size: 4rem; color: #ff3d71"
              icon="close-circle-outline"
            ></nb-icon>
          </div>
          <p>
            This will mark <b>{{ getCancellableJournalsCount() }}</b> journal(s)
            as <b>Cancelled</b>.
          </p>
          <p>All counting activities for these journals will be stopped.</p>
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: space-between; gap: 8px"
          >
          <button
            nbButton
            (click)="ref.close()"
            [disabled]="isCancellingJournals"
            >
            Cancel
          </button>
          <button
            nbButton
            status="danger"
            (click)="cancelSelectedJournals(ref)"
            [disabled]="isCancellingJournals"
            >
            @if (!isCancellingJournals) {
              <span>Cancel Journal(s)</span>
            }
            @if (isCancellingJournals) {
              <i
                class="fa-solid fa-spinner fa-spin"
              ></i>
            }
            @if (isCancellingJournals) {
              <span> Processing...</span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Run Variance Confirmation Dialog -->
    <ng-template #varianceDialog let-data let-ref="dialogRef">
      <nb-card accent="warning">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Run Variance?
        </nb-card-header>
        <nb-card-body>
          <div style="display: flex; justify-content: center">
            <nb-icon
              style="font-size: 4rem; color: #ffaa00"
              icon="alert-circle-outline"
            ></nb-icon>
          </div>
          <p>
            This will run variance on
            <b>{{ getVarianceJournalsCount() }}</b> journal(s).
          </p>
          <p>
            All <b>Waiting</b> items will be marked as <b>Not Found</b> and the
            journal status will be updated.
          </p>
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: space-between; gap: 8px"
          >
          <button nbButton (click)="ref.close()" [disabled]="isRunningVariance">
            Cancel
          </button>
          <button
            nbButton
            status="warning"
            (click)="runVarianceSelectedJournals(ref)"
            [disabled]="isRunningVariance"
            >
            @if (!isRunningVariance) {
              <span>Run Variance</span>
            }
            @if (isRunningVariance) {
              <i
                class="fa-solid fa-spinner fa-spin"
              ></i>
            }
            @if (isRunningVariance) {
              <span> Processing...</span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Complete Count Confirmation Dialog -->
    <ng-template #completeDialog let-data let-ref="dialogRef">
      <nb-card accent="success">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Complete Count?
        </nb-card-header>
        <nb-card-body>
          <div style="display: flex; justify-content: center">
            <nb-icon
              style="font-size: 4rem; color: #00d68f"
              icon="checkmark-circle-2-outline"
            ></nb-icon>
          </div>
          <p>
            This will complete
            <b>{{ getCompletableJournalsCount() }}</b> journal(s).
          </p>
          <p>All counting activities for these journals will be finalized.</p>
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: space-between; gap: 8px"
          >
          <button
            nbButton
            (click)="ref.close()"
            [disabled]="isCompletingJournals"
            >
            Cancel
          </button>
          <button
            nbButton
            status="success"
            (click)="completeSelectedJournals(ref)"
            [disabled]="isCompletingJournals"
            >
            @if (!isCompletingJournals) {
              <span>Complete Count</span>
            }
            @if (isCompletingJournals) {
              <i
                class="fa-solid fa-spinner fa-spin"
              ></i>
            }
            @if (isCompletingJournals) {
              <span> Processing...</span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
  </nb-tab>
  <nb-tab tabTitle="Metrics">
    @if (metricsTabClicked) {
      <stack-mono-equipment-counting-metrics
      ></stack-mono-equipment-counting-metrics>
    }
  </nb-tab>
</nb-tabset>
